module.exports = __webpack_public_path__ + "img/TiNPadInpillar-规则.927ed6de.svg";